/**
 * Entry.
 *
 * Module entry point.
 */

import './menu';
